import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-has-no-itens',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './has-no-itens.component.html',
  styleUrl: './has-no-itens.component.scss',
})
export class HasNoItensComponent {
  @Input()
  public title: string = '';

  @Input()
  public labelButton: string = '';

  @Input()
  public route: string = '';
}
